"use strict";
exports.__esModule = true;
exports.stxt = exports.addStxt = void 0;
var stxts = {
    "Claim already in progress, can't update.": "De aanvraag is al in behandeling genomen en kan daarom niet meer worden aangepast. Voor aanpassingen moet u telefonisch contact opnemen via 0251 49 13 87.",
    "Request failed with status code 422": "Formulier is niet valide: controleer uw invoer",
    "User not found": "Inloggen mislukt: controleer uw gegevens",
    "should NOT be shorter than 1 characters": "Dit veld dient gevuld te zijn.",
    'moet aan dit patroon voldoen "^[\\d+ -]{10,}$"': "Dit veld dient een geldig telefoonnummer te bevatten.",
    'should match format "password"': "Een wachtwoord is ten minste 8 karakters",
    'should match pattern "^[\\d+ -]{10,}$"': "Dit veld dient een geldig telefoonnummer te bevatten.",
    agreeToTerms: "Accepteer voorwaarden",
    adminUserId: "Administrator",
    administrator: "Administrator",
    approved: "Toegewezen",
    auditor: "Auditor",
    calculation: "Toekenning",
    createdAt: "Aangemaakt op",
    evaluating: "1e Beoordeling",
    evaluatorUserId: "1e Beoordelaar",
    "false": "Nee",
    finalReviewerUserId: "2e Beoordelaar",
    finalReviewing: "2e Beoordeling",
    fullGrownChild: "Meerderjarig kind (zie voorwaarden)",
    id: "ID",
    intake: "Intake",
    internalComment: "Interne opmerking",
    externalComment: "Externe opmerking",
    isEmployee: "Medewerker",
    isWidower: "Weduwe/Weduwnaar",
    partnerBirthDate: "Geboortedatum partner",
    partnerName: "Naam partner",
    name: "Naam",
    originalPaperEmailClaimFileIds: "Originele aanvraag",
    open: "Nieuw",
    own: "Eigen",
    parts: "Onderdeel",
    personnelNumber: "Personeelsnummer",
    phone: "Telefoonnummer",
    publicTransport: "Openbaar Vervoer",
    rapCode: "RAP code",
    rejectedConfirmed: "Afgewezen",
    rejectedUnconfirmed: "Afgewezen (onbevestigd)",
    reviewer: "Beoordelaar",
    spouse: "Echtgeno(o)te / partner / zelf",
    status: "Status",
    streetNumberAddition: "Huisnummer toevoeging",
    "true": "Ja",
    type: "Type",
    underageChild: "Inwonend kind (jonger dan 18 jaar)",
    updatedAt: "Bijgewerkt op",
    paymentFileCreatedAt: "Betalingsfile aangemaakt op"
};
function addStxt(key, value) {
    stxts[key] = value;
}
exports.addStxt = addStxt;
function stxt(key) {
    var _a;
    return (_a = stxts[key]) !== null && _a !== void 0 ? _a : key;
}
exports.stxt = stxt;
